import axios from 'axios'

const state = {
  syncStatus: 'idle', // idle, syncing, completed, error
  lastSyncTime: null,
  syncLog: [],
  syncConfig: {
    autoSync: false,
    syncInterval: 60, // phút
    syncFields: {
      personalInfo: true,
      position: true,
      department: true,
      workStatus: true
    }
  },
  apiConfig: {
    baseUrl: '',
    apiKey: '',
    username: '',
    password: ''
  }
}

const getters = {
  currentSyncStatus: state => state.syncStatus,
  lastSyncTime: state => state.lastSyncTime,
  syncLogs: state => state.syncLog,
  syncConfig: state => state.syncConfig,
  apiConfig: state => state.apiConfig,
  
  // Kiểm tra trạng thái đồng bộ
  isSyncing: state => state.syncStatus === 'syncing',
  
  // Kiểm tra cấu hình API đã đầy đủ
  isApiConfigured: state => {
    const { baseUrl, apiKey, username, password } = state.apiConfig
    return baseUrl && (apiKey || (username && password))
  }
}

const actions = {
  // Lấy toàn bộ cấu hình
  async fetchConfig({ commit }) {
    try {
      const response = await axios.get('/hrm-sync/config')
      const { api_url, api_key, username, password, auto_sync, sync_interval } = response.data
      
      // Update API config
      commit('setApiConfig', {
        baseUrl: api_url,
        apiKey: api_key,
        username: username,
        password: password
      })

      // Update sync config
      commit('setSyncConfig', {
        autoSync: auto_sync,
        syncInterval: sync_interval
      })

      return response.data
    } catch (error) {
      console.error('Lỗi khi lấy cấu hình:', error)
      throw error
    }
  },

  // Cập nhật toàn bộ cấu hình
  async updateConfig({ commit }, config) {
    try {
      const response = await axios.put('/hrm-sync/config', config)
      
      // Update API config
      commit('setApiConfig', {
        baseUrl: config.api_url,
        apiKey: config.api_key,
        username: config.username,
        password: config.password
      })

      // Update sync config
      commit('setSyncConfig', {
        autoSync: config.auto_sync,
        syncInterval: config.sync_interval
      })

      return response.data
    } catch (error) {
      console.error('Lỗi khi cập nhật cấu hình:', error)
      throw error
    }
  },

  // Kiểm tra kết nối API
  async testConnection({ state }) {
    try {
      const config = {
        api_url: state.apiConfig.baseUrl,
        api_key: state.apiConfig.apiKey,
        username: state.apiConfig.username,
        password: state.apiConfig.password
      }
      const response = await axios.post('/hrm-sync/test-connection', config)
      return response.data
    } catch (error) {
      console.error('Lỗi khi kiểm tra kết nối:', error)
      throw error
    }
  },

  // Thực hiện đồng bộ thủ công
  async startSync({ commit }) {
    try {
      commit('setSyncStatus', 'syncing')
      const response = await axios.post('/hrm-sync/start')
      
      commit('setSyncStatus', 'completed')
      commit('setLastSyncTime', new Date().toISOString())
      commit('addSyncLog', {
        time: new Date().toISOString(),
        status: 'success',
        message: 'Đồng bộ thành công',
        details: response.data
      })
      
      return response.data
    } catch (error) {
      commit('setSyncStatus', 'error')
      commit('addSyncLog', {
        time: new Date().toISOString(),
        status: 'error',
        message: 'Đồng bộ thất bại',
        details: error.message
      })
      console.error('Lỗi khi đồng bộ:', error)
      throw error
    }
  },

  // Lấy lịch sử đồng bộ
  async fetchSyncLogs({ commit }) {
    try {
      const response = await axios.get('/hrm-sync/logs')
      commit('setSyncLog', response.data)
    } catch (error) {
      console.error('Lỗi khi lấy lịch sử đồng bộ:', error)
      throw error
    }
  },

  // Xóa lịch sử đồng bộ
  async clearSyncLogs({ commit }) {
    try {
      await axios.delete('/hrm-sync/logs')
      commit('setSyncLog', [])
    } catch (error) {
      console.error('Lỗi khi xóa lịch sử đồng bộ:', error)
      throw error
    }
  }
}

const mutations = {
  setSyncStatus(state, status) {
    state.syncStatus = status
  },
  setLastSyncTime(state, time) {
    state.lastSyncTime = time
  },
  setSyncConfig(state, config) {
    state.syncConfig = config
  },
  setApiConfig(state, config) {
    state.apiConfig = config
  },
  setSyncLog(state, logs) {
    state.syncLog = logs
  },
  addSyncLog(state, log) {
    state.syncLog.unshift(log) // Thêm log mới vào đầu mảng
    
    // Giới hạn số lượng log lưu trữ
    if (state.syncLog.length > 100) {
      state.syncLog = state.syncLog.slice(0, 100)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}